export const issueTicketTypes = {
  PRINT_ATB: 'PRINT_ATB',
  PRINT_ADYEN_TERMINAL: 'PRINT_ADYEN_TERMINAL',
  EMAIL_PDF: 'EMAIL_PDF',
  DOWNLOAD_PDF: 'DOWNLOAD_PDF'
};

export const availableTicketIssueOptions = {
  stations: [issueTicketTypes.PRINT_ATB, issueTicketTypes.PRINT_ADYEN_TERMINAL, issueTicketTypes.EMAIL_PDF, issueTicketTypes.DOWNLOAD_PDF],
  other: [issueTicketTypes.EMAIL_PDF, issueTicketTypes.DOWNLOAD_PDF]
};
